import { render } from "./Old_UP_Sales.vue?vue&type=template&id=b5cb6676"
import script from "./Old_UP_Sales.vue?vue&type=script&lang=js"
export * from "./Old_UP_Sales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userSupport/Old_UP_Sales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5cb6676"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5cb6676', __exports__)) {
    api.reload('b5cb6676', __exports__)
  }
  
  module.hot.accept("./Old_UP_Sales.vue?vue&type=template&id=b5cb6676", () => {
    api.rerender('b5cb6676', render)
  })

}


export default __exports__